<form [formGroup]="formGroup" class="berg">
  @for (element of elements; track element.name; let i = $index) {
    @if (element.type === "radiogroup") {
      <div class="berg-row">
        <div class="berg-q">
          <div class="berg-q-title">
            <span>{{ i + 1 }}. {{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="berg-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="berg-a">
          <div class="berg-group">
            @for (choice of element.choices; track choice.value) {
              <label class="berg-option">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span class="berg-option-text">{{
                  choice.text | translate
                }}</span>
              </label>
            }
          </div>
        </div>
      </div>
    }
  }

</form>
